<template>
    <div>
        <CustomSelectOne :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                         item-label="label" item-value="value" :label="label" v-if="loading" :required="required"
                         :rules="rules" :placeholder="placeholder" :noPlaceholder="noPlaceholder"
                         :customErrorMessage="customErrorMessage" />
    </div>
</template>

<script>
    import {getUserRoles} from "@/swagger/vue-api-client";
    import CustomSelectOne from "./inner/CustomSelectOne";

    export default {
        name: "CustomSelectOneSystemRole",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            modelValue: null,
            rules: undefined,
            placeholder: {
                type: String,
                default: "",
            },
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
            customErrorMessage: {
                type: String,
                default: "",
            },
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [],
                loading: false,
            };
        },

        beforeMount() {
            getUserRoles().then((response) => {
                this.items = response.data;
                this.loading = true;
            });
        },

        components: {CustomSelectOne},
    };
</script>

<style scoped>

</style>
